import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { useTheme } from "@smartrent/ui";

import HeaderContent, { HeaderContentProps } from "./HeaderContent";

interface HeaderProps extends HeaderContentProps {
  children?: ReactNode;
  style?: object;
}

export default function Header({
  left,
  title,
  right,
  children,
  style,
}: HeaderProps) {
  const { colors } = useTheme();

  return (
    <View
      style={[
        {
          backgroundColor: colors.primary,
        },
        styles.root,
        style,
      ]}
    >
      {children ? (
        children
      ) : (
        <HeaderContent left={left} title={title} right={right} />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    width: "100%",
    height: 80,
    justifyContent: "center",
    overflow: "visible",
    shadowColor: "rgba(45, 50, 57, .2)",
    shadowRadius: 8,
    shadowOffset: {
      width: 0,
      height: 4,
    },
  },
});
